import Axios from 'axios'
import * as React from 'react'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {config} from '../../core/reducers/config'
import {LinearProgress} from '@mui/material'
import {Feature} from '../../core/models'

interface Props {}

interface State {
  loading: boolean
  file?: AttachmentInfo
  afterSuccess: boolean
  error: string
  progress: number
  status: string
}

export class Cad4Convert extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      afterSuccess: false,
      loading: false,
      error: '',
      progress: 0,
      status: ''
    }
  }
  public statusMap = new Map<number, string>()

  getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (this.state.file) {
      adds[this.state.file.name] = this.state.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.cad,.CAD'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            this.setState({...this.state, file: file, error: ''})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }
  getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }
  getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!this.state.file}
        onClick={() => {
          const formData = new FormData()
          formData.append('File', this.state.file!.file!, this.state.file!.name)
          this.setState({...this.state, loading: true}, () => {
            Axios.post(config.getConfig().urls.xyApiUrl + '/cad-convert', formData, {
              headers: {'Content-Type': `multipart/form-data;`},
              onUploadProgress: progressEvent => {
                const progress = progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 100 : 0
                this.setState({...this.state, progress: progress})
              }
            })
              .then(r => {
                this.setState({...this.state, afterSuccess: true, error: '', loading: false, status: r.data})
              })
              .catch(error => {
                if (error.response && error.response.data && error.response.data) {
                  this.setState({...this.state, error: error.response.data})
                } else {
                  this.setState({...this.state, error: 'Възникна грешка ' + error.message, loading: false})
                }
              })
          })
        }}
      >
        Конвертирай в DXF
      </button>
    )
  }
  afterSuccess() {
    return (
      <div>
        <div className="success-div">
          <a href={config.getConfig().urls.xyApiUrl + '/' + this.state.status}>Свали</a>
        </div>
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined})
          }}
        >
          Ново конвертиране
        </button>
      </div>
    )
  }

  onerror() {
    return (
      <div className="error-div">
        <button
          type="button"
          className="button width"
          onClick={() => {
            this.setState({...this.state, afterSuccess: false, file: undefined, error: ''})
          }}
        >
          Ново конвертиране
        </button>
        {this.state.error}
      </div>
    )
  }

  render() {
    return (
      <div style={{padding: '10px', boxSizing: 'border-box', height: '80%', overflow: 'auto'} as React.CSSProperties}>
        {this.state.afterSuccess ? (
          this.afterSuccess()
        ) : this.state.error ? (
          this.onerror()
        ) : (
          <div style={{position: 'relative'}}>
            <OverlayLoader show={this.state.loading}></OverlayLoader>

            {this.getContainer(this.getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
            {this.getExecuteButton()}
            {this.state.loading ? <LinearProgress variant="determinate" value={this.state.progress} /> : null}
          </div>
        )}
      </div>
    )
  }
}
